import React from 'react';
import netteApiClient from '../../../Services/NetteApiClient';
import { useAppContext } from '../../../Services/AppContext';
import Video from '../../Base/Components/Video/Video';

interface Props {
	video: string;
}

const VideoWithAutoSubmit: React.FC<Props> = ({ video }) => {
	// @ts-ignore
	const { onAutoSubmit } = useAppContext();

	const handleVideoEnd = () => {
		setTimeout(() => {
			netteApiClient.get(onAutoSubmit);
		}, 1000);
	};

	return (
		<div>
			<Video
				videoSrc={video}
				className='videoWrapper__video'
				autoPlay
				controls
				onEnded={handleVideoEnd}
			/>
		</div>
	);
};

export default VideoWithAutoSubmit;
